import { george, i18n, pr } from "aaa";
import { GdsFakeActionButton } from "components/common/GdsFakeActionButton";
import { ui } from "components/util/uiHelpers";
import { observer } from "mobx-react";
import * as React from "react";
import { pushRoute } from "stores/RouterFunctions";
import { removeWhitespace } from "util/helpers";
import { IchAppRoutes } from "./IchAppRoutes";
import { IchAppStore } from "./IchAppStore";
import { GdsFakeActionButtonContainer } from "components/common/GdsFakeActionButtonContainer";
import externalInterfaceStore from "stores/ExternalInterfaceStore";

type IProps = {
    store: IchAppStore
};

export const IchAppEmailVerification = observer(({ store }: IProps) => {

    const [resendCode, setResendCode] = React.useState(false);
    const [loading, setLoading] = React.useState(false);

    const handleResendCode = async () => {
        try {
            setResendCode(true);
            setErrorMessage("");
            await store.postResendValidationCode();
        } catch (error) {
            pushRoute("/error");
        } finally {
            setResendCode(false);
        }
    };

    const [code, setCode] = React.useState("");
    const [errorMessage, setErrorMessage] = React.useState("");

    const handleSendCode = async () => {
        try {
            setLoading(true);
            await store.putRegistration(code);
            pushRoute(IchAppRoutes.CONTRACT);
        } catch (error) {
            const errorCode = error.response?.errors?.[0]?.code;
            if (errorCode === "INVALID_FIELD_VALUE") {
                setErrorMessage(ui.__("ichApp.error.invalidCode"));
            } else if (errorCode === "USER_LOCKED") {
                setErrorMessage(ui.__("ichApp.error.userLocked"));
            }
        } finally {
            setLoading(false);
        }
    };

    return (

        <george.Card
            elevated={false}
            style={{ borderRadius: 8 }}
        >
            <div style={{ lineHeight: "24px" }}>
                <div style={{ textAlign: "center", padding: "32px 16px" }}>
                    <pr.IconMailXL style={{ color: "#135EE2", width: 48, height: 48, marginBottom: 16 }} />
                    <pr.P_22_TITLE style={{ fontWeight: 700, lineHeight: "28px", textAlign: "center", marginTop: 16 }}>
                        {ui.__("ichApp.emailVerification.title")}
                    </pr.P_22_TITLE>
                    <pr.P_16_CONTENT style={{ textAlign: "left", marginTop: 32 }}>
                        <i18n.FormattedHTMLMessage id="ichApp.emailVerification.text" values={{ email: store.contactsStore.selectedEmailAddress?.email?.email ?? "" }} />
                    </pr.P_16_CONTENT>
                    <pr.P_16_CONTENT style={{ fontWeight: 700, marginTop: 32 }}>
                        {ui.__("ichApp.emailVerification.resend.text")}
                    </pr.P_16_CONTENT>

                    <GdsFakeActionButton style={{ marginTop: 8, padding: "0px 8px", display: "inline-block" }} disabled={resendCode} onClick={handleResendCode}>
                        {ui.__("ichApp.emailVerification.resend.button")}
                    </GdsFakeActionButton>

                    <george.TextField
                        style={{ marginTop: 32, textAlign: "left" }}
                        label={ui.__("ichApp.emailVerification.input.label")}
                        id="verification-code"
                        hintText="_ _ _ _"
                        onChange={(e) => {
                            const cleaned = removeWhitespace(e.target.value);
                            const value = Number(cleaned);
                            if (Number.isInteger(value) && value >= 0 && value <= 9999 && cleaned.length <= 4) {
                                setCode(cleaned);
                                setErrorMessage("");
                            }
                        }}
                        inputStyle={{ fontSize: 24, fontVariantNumeric: "tabular-nums" }}
                        value={code}
                        errorMessage={errorMessage}
                    />
                </div>


                <pr.LightSeparatorLine />

                <GdsFakeActionButtonContainer>
                    <GdsFakeActionButton
                        color="primary"
                        onClick={handleSendCode}
                        disabled={loading}
                        isLoading={loading}
                        fullWidth={externalInterfaceStore.isGeorgeApp}
                    >
                        {ui.__("button.continue")}
                    </GdsFakeActionButton>
                    <GdsFakeActionButton onClick={() => pushRoute(IchAppRoutes.REGISTRATION)} fullWidth={externalInterfaceStore.isGeorgeApp}>
                        {ui.__("common.back")}
                    </GdsFakeActionButton>
                </GdsFakeActionButtonContainer>
            </div>
        </george.Card>
    );
});



// WEBPACK FOOTER //
// ./src/components/ichApp/IchAppEmailVerification.tsx